import React, {useEffect, useState} from "react";
import {Image, Modal} from "antd";
import WECOM_HITER_QR_URL from 'asset/images/wecom-hiter.png'
import FU_WU_HAO_QR_URL from 'asset/images/qrcode_for_fuwuhao.jpg'
import './index.scss'
const PaiPointFooter: React.FC = () => {
    const [openContactUsModal, setOpenContactUsModal] = useState(false);
    const showContactUsModal = () => {
        setOpenContactUsModal(true)
    }

    return (
        <div className={'pai-point-footer-container'}>
            <div className={'footer-container'}>
                <div className={'website-information'}>
                    <span>· 甘井子区派点软件信息技术服务中心 ·</span>
                    <a href={'https://beian.miit.gov.cn/'}>辽ICP备2024033978号-1</a>
                </div>
                <div className={'we-com-qrcode'}>
                    <span className={'contact-us-text'} onClick={showContactUsModal}>
                        联系我们
                    </span>
                </div>
                <div className={'footer-slogan'}>
                    Made by Pai-Point Software Information Technology Service Center
                </div>
            </div>
            <Modal
                title="联系我们"
                wrapClassName={'contact-us-modal'}
                centered
                open={openContactUsModal}
                footer={null}
                onCancel={() => setOpenContactUsModal(false)}
            >
                <div className={'contact-us-modal-container'}>
                    <div className={'image-item'}>
                        <Image width={200} height={200} src={WECOM_HITER_QR_URL}/>
                        <div className={'image-title'}>企业微信</div>
                    </div>
                    <div className={'image-item'}>
                        <Image width={200} height={200} src={FU_WU_HAO_QR_URL}/>
                        <div className={'image-title'}>微信公众号</div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default PaiPointFooter;